var serviceList = jQuery(".listServices > div");
var title_step2 = jQuery(".title_step2");
var title_step3 = jQuery(".title_step3");

serviceList.hide();


jQuery( ".step1_buttons input:radio" ).each(function(index) {
    jQuery(this).on("click", function(){
        var indexEl = index;
        var ServiceText = jQuery(this).next().text();
        // alert(indexEl+" "+ServiceText);
        serviceList.hide();
        serviceList.eq(indexEl).show();
        title_step2.text(ServiceText);
        title_step3.text(ServiceText);
    });
});

jQuery( ".cf7mls_next,.cf7mls_back").each(function(index) {
    jQuery(this).on("click", function(){

        // alert("ertert");

        jQuery('html, body').animate({
            scrollTop: jQuery("#formularTop").offset().top
        }, 500);

    });
});